//
//
//
//
//
//
//
//

export default {
  name: 'ContentToggler',
  data() {
    return {
      isActive: false,
    }
  },
  methods: {
    toggleActivity() {
      this.isActive = !this.isActive
    },
  },
}
